import actionTypes from './index';

export default () => (dispatch) => {
  dispatch({
    type: actionTypes.SHARE_MODAL_DISMISSED,
  });
};
